
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/block/countdown",
      function () {
        return require("private-next-pages/block/countdown/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/block/countdown"])
      });
    }
  